


import httpClient from '@/httpClient';

class FileService {
  /** Fichier privé servi par l'API (chemin « /api/… ») : téléchargé avec le jeton de l'utilisateur, jamais par URL publique. */
  fetchProtected = async (apiPath: string) => {
    const response = await httpClient.get(apiPath.replace(/^\/api/, ''), { responseType: 'blob' });
    return { blob: response.data as Blob, fileName: this.getFileName(response.headers) };
  };
  openProtected = async (apiPath: string) => {
    const { blob } = await this.fetchProtected(apiPath);
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  };
  /** Média d'un conteneur privé (documents de bus, pièces d'identité…) : lu par l'API, qui vérifie droits et compagnie. */
  downloadMedia = async (fileUrl: string, container: number) => {
    const response = await httpClient.post('/commons/medias/download', null, { params: { fileUrl, container }, responseType: 'blob' });
    this.saveByte2File(this.getFileName(response.headers) || fileUrl.split('/').pop() || 'document', response.data);
  };
  /** Ouvre (aperçu) un média d'un conteneur privé, lu par l'API avec droits et compagnie vérifiés. */
  openMedia = async (fileUrl: string, container: number) => {
    const response = await httpClient.post('/commons/medias/download', null, { params: { fileUrl, container }, responseType: 'blob' });
    const url = window.URL.createObjectURL(response.data);
    window.open(url, '_blank');
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  };
  downloadProtected = async (apiPath: string, fallbackName: string) => {
    const { blob, fileName } = await this.fetchProtected(apiPath);
    this.saveByte2File(fileName || fallbackName, blob);
  };

  downloadFileWithUrl = (url: string) => {
    try {
      const a: any = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.target = '_blank'
      a.click();
      window.setTimeout(() => {
        document.body.removeChild(a);
      }, 200);
    } catch (error) {
      console.log(error);
    }
  }
  saveByte2File = (fileName: string, blob) => {
    try {
      const a: any = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      const url = window.URL.createObjectURL(new Blob([blob]));
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      window.setTimeout(() => {
        document.body.removeChild(a);
      }, 200);
    } catch (error) {
      console.log(error);
    }
  };
  getFileName = (header: any) => {
    var disposition = header['content-disposition'];
    if (disposition) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
      }
    }
    return '';
  };
}

export const fileService = new FileService();
